// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoneContentBox_container__WbDUQ {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
}

.NoneContentBox_none_img__3cbaT {
    width: 217px;
    height: 216px;
    margin-bottom: 42px;
}

.NoneContentBox_none_text__vNEPD {
    font-size: 24px;
    color: #101417;
    margin-bottom: 24px;
}

.NoneContentBox_none_explain__ZCTzF {
    font-size: 16px;
    color: #414648;
    margin-bottom: 24px;
}

.NoneContentBox_create_butn__KXYKT {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 58px;
    border-radius: 6px;
    color: #fff;
    background-color: #17A8B5;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/collect/components/NoneContentBox/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.none_img {\n    width: 217px;\n    height: 216px;\n    margin-bottom: 42px;\n}\n\n.none_text {\n    font-size: 24px;\n    color: #101417;\n    margin-bottom: 24px;\n}\n\n.none_explain {\n    font-size: 16px;\n    color: #414648;\n    margin-bottom: 24px;\n}\n\n.create_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 300px;\n    height: 58px;\n    border-radius: 6px;\n    color: #fff;\n    background-color: #17A8B5;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NoneContentBox_container__WbDUQ`,
	"none_img": `NoneContentBox_none_img__3cbaT`,
	"none_text": `NoneContentBox_none_text__vNEPD`,
	"none_explain": `NoneContentBox_none_explain__ZCTzF`,
	"create_butn": `NoneContentBox_create_butn__KXYKT`
};
export default ___CSS_LOADER_EXPORT___;
